module.exports = __webpack_public_path__ + "static/media/perfect-gold_00013.db4576d0.png";